import { AddHost } from '@/features/store-management/basic-stores/AddHostManagement';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/store-information/basic-stores/host-management/$clubid/add-host/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <AddHost />;
}
